import { useEffect, useMemo, useState } from 'react'
import FortuneBasketCard from './FortuneBasketCard'
import { compareProductSortOrder, fetchProducts } from '../../api/productApi'

/**
 * Horizontal product strip used on Wishlist / Cart pages.
 * Shows all shop products (optionally excluding current list ids).
 */
const RelatedProductsSection = ({ excludeIds = [] }) => {
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    fetchProducts()
      .then((data) => {
        if (!cancelled) setProducts(data || [])
      })
      .catch(() => {
        if (!cancelled) setProducts([])
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  const excludeSet = useMemo(
    () => new Set((excludeIds || []).map(String).filter(Boolean)),
    [excludeIds]
  )

  const relatedProducts = useMemo(
    () =>
      [...products]
        .filter((item) => !excludeSet.has(String(item.product_id)))
        .sort(compareProductSortOrder),
    [products, excludeSet]
  )

  if (loading || relatedProducts.length === 0) return null

  return (
    <section className="related-products-section mt-5 pt-2">
      <div className="d-flex justify-content-between align-items-end mb-3">
        <h3 className="text-lora font-semibold mb-0">Related Products</h3>
      </div>
      <div className="row g-3 flex-nowrap overflow-auto fortune-scroll-row pb-2">
        {relatedProducts.map((item) => (
          <div
            className="col-10 col-sm-6 col-md-4 col-lg-3"
            key={item.product_id}
          >
            <FortuneBasketCard item={item} />
          </div>
        ))}
      </div>
    </section>
  )
}

export default RelatedProductsSection
